import { render, staticRenderFns } from "./VistaListaClientes.vue?vue&type=template&id=072d6dde"
import script from "./VistaListaClientes.vue?vue&type=script&lang=js"
export * from "./VistaListaClientes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports